var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-box p-5"},[_c('div',{staticClass:"c-box__content"},[_vm._v("\n        Please wait while we are logging you in "),_c('br'),_vm._v("\n        "+_vm._s(_vm.error_text)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }